import React, { Component } from 'react';
import Recommender from 'pages/Recommender/Recommender';
import Analytics from '../../utils/analytics';

import { ieVersion } from 'utils/helpers';

Analytics.init();

class App extends Component {  
  render() {
    const explorerVersion = ieVersion();
    const isIe = explorerVersion && explorerVersion <= 11;

    return (
      <div className={"App" + (isIe ? " is-ie" : "") }>
        <Recommender />
      </div>
    );
  }
}

export default App;
